let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j2bbk")).then(() => parcelRequire('5csm1'));